import { sdkv1 } from "@models/api";
import * as Cookies from "cookies-next"
import axios, { CancelTokenSource } from "axios";

const CancelToken = axios.CancelToken;
let source: CancelTokenSource | null = null;

export async function searchCategories(searchInput: string, index?: string) {
  if (!source) {
    source = CancelToken.source();
  } else {
    source.cancel();
    source = null;
  }

  index = (index !== "memos") ? `&index=${index}` : "";
  const { data } = await sdkv1.http.http
  .get(`/search?q=${encodeURIComponent(searchInput)}${index}&light=true&limit=25&page=1`,
    {
      cancelToken: source?.token,
      headers: {
        authorization: Cookies.getCookie("token") ?? "",
      }
    });
  source = null;
  return data.results;
}

export async function searchRecommendationCategories(index?: string) {
  index = (index !== "memos") ? `&index=${index}` : "&=false";
  const { data } = await sdkv1.http.http.get(`/search?q=memo-empty-search-recommendation${index}&light=true&limit=25&page=1`,
    {
      headers: {
        authorization: Cookies.getCookie("token") ?? "",
      }
    });
  return data.results;
}

export async function generalSearch(query: string, index = "", page = 1, limit = 25) {
  index = (index !== "memos") ? `&index=${index}` : "";
  const { data } = await sdkv1.http.http.get(`/search?q=${query}&light=true&limit=${limit}&page=${page}${index}`,
    {
      headers: {
        authorization: Cookies.getCookie("token"),
      }
    });
  return data.results;
}